export default "__VITE_ASSET__iCll0F$P__"